module.exports = __webpack_public_path__ + "static/img/banner-column-new.8cba8fd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/specialColumn/banner-column-new.jpg
// module id = p8P6
// module chunks = 0